type SubmitShareTargetsInput = {
  isSharedWithAllEnabled: boolean
  selectedOrganizationIds: number[]
}

type ShareableOrganization = {
  id: number
  isRequested: boolean
  hasAccess: boolean
}

type ContinueButtonInput = {
  isLoading: boolean
  isSharedWithAllEnabled: boolean
  selectedCount: number
  shareableCount: number
}

// With "share with all" the backend resolves the accessors itself (every accessor for a standard
// report, the template's SharedTemplates for a custom one) and ignores the ids sent from here.
export const organizationIdsToShareWithOnSubmit = ({
  isSharedWithAllEnabled,
  selectedOrganizationIds,
}: SubmitShareTargetsInput): number[] => (isSharedWithAllEnabled ? [] : selectedOrganizationIds)

export const organizationIdsSelectedByDefault = (organizations: ShareableOrganization[]): number[] =>
  organizations.filter(o => o.hasAccess || o.isRequested).map(o => o.id)

export const isContinueDisabled = ({
  isLoading,
  isSharedWithAllEnabled,
  selectedCount,
  shareableCount,
}: ContinueButtonInput): boolean => isLoading || (!isSharedWithAllEnabled && selectedCount === 0 && shareableCount > 0)
